import React from 'react'
import { Typography, Box } from '@material-ui/core'
import useStyles from './styles'
import { useStyles as useEditFormStyles } from 'pages/pga-coach/bookings/events/edit/edit-event-form/styles'
import BookingTypeVisibility from './booking-type-visibility'
import BookingTypeAccessCode from './booking-type-access-code'
import BookingTypeGifting from './booking-type-gifting'
import { useFormContext } from 'react-hook-form'
import DebouncedMarkdownRichTextEditor from 'lib/rte-utils/debounced-markdown-rich-text-editor'
import { optionalLabel } from './required-field'

const BookingTypeAdditionalOptions = ({
  status,
  setStatus,
  bookingType,
  isLessonPacks,
  giftingEnabled,
  setGiftingEnabled,
  isEditFlow = false,
}) => {
  const classes = useStyles()
  const editClasses = useEditFormStyles()
  const { errors, register, setValue } = useFormContext()

  return (
    <>
      {isLessonPacks ? (
        <BookingTypeGifting
          giftingEnabled={giftingEnabled}
          setGiftingEnabled={setGiftingEnabled}
        />
      ) : null}
      <BookingTypeVisibility
        status={status}
        setStatus={setStatus}
        isEditFlow={isEditFlow}
      />
      <BookingTypeAccessCode
        bookingType={bookingType}
        classes={classes}
        register={register}
        errors={errors}
        setValue={setValue}
        isEditFlow={isEditFlow}
      />
      <Box className={isEditFlow ? editClasses.fieldGroup : undefined}>
        {isEditFlow ? (
          <>
            <Typography className={editClasses.sectionHeading}>
              {optionalLabel('Confirmation Message')}
            </Typography>
            <Typography className={editClasses.fieldHelper}>
              This message will appear on the confirmation email to your
              student. Use this space to communicate next steps such as where to
              meet or a video URL.
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="subtitle1" gutterBottom>
              {optionalLabel('Confirmation Message')}
            </Typography>
            <Typography variant="body2" gutterBottom>
              This message will appear on the confirmation email to your
              student. Use this space to communicate the next steps to your
              student (where to meet, video url, anything else that is important
              to the session).
            </Typography>
          </>
        )}
        <Box
          className={isEditFlow ? editClasses.editorRoot : classes.editorRoot}
        >
          <DebouncedMarkdownRichTextEditor
            name="confirmationMessage"
            label="Create confirmation"
            controls={['bold', 'italic', 'strikethrough', 'bulletList', 'link']}
          />
        </Box>
      </Box>
    </>
  )
}

export default BookingTypeAdditionalOptions
